import * as types from './types';
import * as I18nTypes from '../i18n/types';
import { AccountService } from '../../../services/account.service';
import { MODIFICATION_URL } from '../../../services/common-urls';
import { HttpClient } from '../../../services/http/http-client';

export const accountActions = {
  async [types.GET_APP_INIT_DATA]({ commit, getters, dispatch }) {
    // const userInfo = await AccountService.findUserInfo();
    const appData = await AccountService.getV2InitData();
    commit(types.SET_ACCOUNT_INFO, appData);
    console.log({ "appData": appData });
    const language = appData.user.language || 'en';
    
    dispatch(I18nTypes.UPDATE_SYSTEM_LANGUAGE,
      getters.systemLanguagesTV.find((e) => e.value == language)
    );
    return appData;
  },
  async [types.UPDATE_INAPPNOTICE]({ commit }, payload) {
    commit(types.UPDATE_INAPPNOTICE, payload);
  },
  async [types.UPDATE_ACCOUNT_INFO]({ commit }, payload) {
    console.log(payload);
    const { user, name, value } = payload;


    const key = 'user_id';
    const kVal = user[key];
    const table = 'users';

    commit(types.UPDATE_ACCOUNT_INFO, { name, value });



    const updateUser = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );
  },
  async [types.UPDATE_CLIENT]({ commit, getters }, payload) {
    const { name, value } = payload;

    commit(types.SET_ACCOUNT_INFO, {
      ...getters.account,
      client: {
        ...getters.account.client,
        [name]: value,
      }
    });

    const updatedClient = await HttpClient.post(MODIFICATION_URL, {
      key: 'clientID',
      kVal: getters.account.client.clientID,
      table: 'clients',
      name,
      value,
    });

  }
}